import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { OnboardingLayout } from '../Layout/Layout'

import { Box } from '@percent/lemonade'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { LinkButton } from '@percent/domain/giving'
import { useAnalytics } from '@percent/workplace-giving/common/hooks/useAnalytics/useAnalytics'
import { usePermission } from '@percent/workplace-giving/common/hooks/usePermission/usePermission'
import { scope } from '@percent/workplace-giving/common/hoc/withPermissions'
import {
  DonationsOnlyPlatformTourItems,
  FullFeaturedPlatformTourItems,
  VolunteeringOnlyPlatformTourItems
} from './PlatformTourItems'
import classes from './PlatformTour.module.scss'

export function PlatformTour() {
  const { t } = useTranslation()
  const has = usePermission()
  const { track } = useAnalytics()
  const { search } = useLocation()

  const donationsEnabled = has(scope('donation_link'))
  const volunteeringEnabled = has(scope('volunteering'))

  const items = useMemo(() => {
    if (volunteeringEnabled && donationsEnabled) return <FullFeaturedPlatformTourItems />

    if (donationsEnabled) return <DonationsOnlyPlatformTourItems />

    if (volunteeringEnabled) return <VolunteeringOnlyPlatformTourItems />

    return null
  }, [volunteeringEnabled, donationsEnabled])

  return (
    <OnboardingLayout
      cardTitle={t('workplace_giving.onboarding.platform_tour.title')}
      cardDescription={t('workplace_giving.onboarding.platform_tour.description')}
      cardClassName={classes.card}
      footer={
        <Box className={classes.buttonsWrapper}>
          <LinkButton
            to={`${AppRoute.ONBOARDING_SUCCESS}${search}`}
            variant="primary"
            shape="oval"
            replace
            onClick={() => track({ event: 'Onboarding Ways to Give CTA Clicked' })}
          >
            {t('workplace_giving.common.continue')}
          </LinkButton>
        </Box>
      }
    >
      {items}
    </OnboardingLayout>
  )
}
